@if(canConfigure) {
    <button mat-icon-button [matMenuTriggerFor]="componentMenu"
    aria-label="Settings icon to open the menu for the component configuration">
    <mat-icon>settings</mat-icon>
</button>
}

<mat-menu #componentMenu="matMenu">
    @if(canDelete) {
    <button mat-menu-item (click)="removeComponent()">
        <mat-icon>delete</mat-icon>
        <span>Komponente löschen</span>
    </button>
}

    @if(canModifyGroupedElements) {
    <button mat-menu-item [matMenuTriggerFor]="groupedElementsMenu">
        <mat-icon>tune</mat-icon>
        <span>{{ LabelDisplay }}</span>
    </button>
    }

    @if(hasAction) {
    <button mat-menu-item (click)="triggerAction(hasAction.action)">
        <mat-icon>{{hasAction.icon}}</mat-icon>
        <span>{{ hasAction.label }}</span>
    </button>
    }
</mat-menu>

<mat-menu #groupedElementsMenu="matMenu">
    <button mat-menu-item (click)="removeGroupedElementFromComponent()">
        <mat-icon>{{ removeIcon }}</mat-icon>
        <span>{{ removeLabel }}</span>
    </button>
    <button mat-menu-item (click)="addGroupedElementToComponent()">
        <mat-icon>{{ addIcon }}</mat-icon>
        <span>{{ addLabel }}</span>
    </button>
</mat-menu>